import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import SearchDropdown from "../../../../../../search/seatchDropdown";

export default class CreateBrand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "Edit Brand | Chimera Solutions | Insights",
      form: {
        state: null,
        message: "",
      },
      field: {
        group: {
          data: [],
          value: "",
          message: "",
          state: null,
        },
        name: {
          value: "",
          message: "",
          state: null,
        },
        level: {
          value: [],
          message: "",
          state: null,
        },
        user: {
          value: [
            {
              id: "",
              name: "",
              state: null,
            },
          ],
          data: [],
          rawData: [],
          message: "",
          state: null,
        },
      },
    };

    this.valueChanged = this.valueChanged.bind(this);

    this.headers = {
      Authorization: this.props.user.data.usrKey,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  valueChanged = (event) => {
    const element = event.target;

    if (element.getAttribute("data-field")) {
      const field = element.getAttribute("data-field");
      const key = Number(element.getAttribute("data-key"));

      this.setState((prevState) => {
        const value = prevState.field[field].value.map((data, index) => {
          if (index === key) {
            switch (field) {
              case "level":
                return {
                  ...data,
                  status: data.status ? 0 : 1,
                };
              default:
                return data;
            }
          }
          return data;
        });

        return {
          field: {
            ...prevState.field,
            [field]: {
              ...prevState.field[field],
              value: value,
              message: "",
              state: null,
            },
          },
          form: {
            state: false,
          },
        };
      });
    } else {
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          [element.id]: {
            ...prevState.field[element.id],
            value: element.value,
            message: "",
            state: null,
          },
        },
        form: {
          state: false,
        },
      }));
    }

    this.checkField(element);
  };

  valdidateLevelStates = () => {
    this.setState(
      (prevState) => ({
        field: {
          ...prevState.field,
          level: {
            ...prevState.field.level,
            state: this.state.field.level.value.filter((level) => level.status)
              .length
              ? true
              : false,
          },
        },
      }),
      () => this.validateFields()
    );
  };

  checkField = (data) => {
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      if (data.getAttribute("data-field")) {
        const field = data.getAttribute("data-field");

        switch (field) {
          case "level":
            let state = true;
            let message = "";

            const checkLevels = this.state.field.level.value.filter(
              (level) => level.status
            ).length;

            if (!checkLevels) {
              state = false;
              message = "please select a user level";
            }

            this.setState(
              (prevState) => {
                return {
                  field: {
                    ...prevState.field,
                    [field]: {
                      ...prevState.field[field],
                      message: message,
                      state: state,
                    },
                  },
                };
              },
              () => this.valdidateLevelStates()
            );
            break;
          default:
            break;
        }
      } else {
        switch (data.id) {
          case "group":
            this.setState((prevState) => ({
              field: {
                ...prevState.field,
                group: {
                  ...prevState.field.group,
                  value: "",
                  state: null,
                },
                level: {
                  ...prevState.field.level,
                  value: [],
                  state: null,
                  message: "",
                },
                user: {
                  ...prevState.field.user,
                  value: [
                    {
                      id: "",
                      name: "",
                      state: null,
                    },
                  ],
                  data: [],
                  state: null,
                  message: "",
                },
              },
            }));

            if (data.value !== "0") {
              const group = JSON.parse(data.value);

              this.setState(
                (prevState) => ({
                  field: {
                    ...prevState.field,
                    group: {
                      ...prevState.field.group,
                      value: group.grpKey,
                      state: true,
                    },
                    level: {
                      ...prevState.field.level,
                      value: this.state.field.group.data
                        .find((res) => res.grpKey === group.grpKey)
                        .levels.map((level, key) => {
                          let status = 0;

                          if (!key) {
                            status = 1;
                          }

                          return { ...level, status: status };
                        }),
                    },
                    user: {
                      ...prevState.field.user,
                      data: this.state.field.user.rawData.filter(
                        (user) => user.group === group._id
                      ),
                    },
                  },
                }),
                () => this.valdidateLevelStates()
              );
            }
            break;
          case "name":
            if (data.value.length) {
              let state = true;
              let message = "";

              if (data.value.length <= 3) {
                state = false;
                message = "brand name should be minimum of 4 characters \n";
              }

              if (
                [].concat
                  .apply(
                    [],
                    [].concat.apply(
                      [],
                      this.state.field.group.data.map((data) =>
                        data.brands.map((brand) => brand.name)
                      )
                    )
                  )
                  .find((name) => name === data.value)
              ) {
                state = false;
                message = "brand name exist \n";
              }

              this.setState(
                (prevState) => ({
                  field: {
                    ...prevState.field,
                    [data.id]: {
                      ...prevState.field[data.id],
                      value: data.value,
                      state: state,
                      message: message,
                    },
                  },
                }),
                () => this.validateFields()
              );
            }
            break;
          default:
            break;
        }

        this.validateFields();
      }
    }, 500);
  };

  validateFields = () => {
    this.setState((prevState) => ({
      form: {
        state: false,
      },
    }));

    if (
      this.state.field.name.state &&
      this.state.field.group.state &&
      this.state.field.level.state
    ) {
      this.setState((prevState) => ({
        form: {
          state: true,
        },
      }));
    }
  };

  checker(state) {
    const check = {
      icon: "check-circle",
      style: "null",
    };

    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }

    return check;
  }

  renderTitle = () => (
    <Helmet>
      <title>{this.state.title}</title>
    </Helmet>
  );

  handleChange = (date) => {
    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        accntExp: date,
      },
    }));
  };

  getUser = async () => {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/user",
        { headers: this.headers }
      );
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          user: {
            ...prevState.field.user,
            rawData: response.data,
          },
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  getGroup = async () => {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/group",
        { headers: this.headers }
      );
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          group: {
            ...prevState.field.group,
            data: response.data,
          },
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  componentDidMount = () => {
    this.getGroup();
    this.getUser();
  };

  reset = () =>
    this.setState({
      reset: new Date().getTime(),
    });

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.reset !== this.state.reset) {
      this.setState((prevState) => ({
        form: {
          state: false,
          message: "",
        },
        field: {
          ...prevState.field,
          group: {
            value: "",
            data: [],
            message: "",
            state: null,
          },
          name: {
            value: "",
            message: "",
            state: null,
          },
          level: {
            data: [],
            value: [],
            message: "",
            state: null,
          },
          user: {
            ...prevState.field.user,
            data: [],
            value: [
              {
                id: "",
                name: "",
                state: null,
              },
            ],
            message: "",
            state: null,
          },
        },
      }));

      this.getGroup();
    }
  };

  add = () => {
    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        user: {
          ...prevState.field.user,
          value: [
            ...prevState.field.user.value,
            {
              id: parseInt(prevState.field.user.value.length + 1),
              name: "",
              state: null,
            },
          ],
          message: "",
          state: null,
        },
      },
    }));
  };

  remove = (key) => {
    const newUsers = [].concat(
      [],
      this.state.field.user.value.filter((vale, index) => key !== index)
    );

    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        user: {
          ...prevState.field.user,
          value: newUsers,
          message: "",
          state: null,
        },
      },
    }));
  };

  submit = async () => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        state: false,
        message: "",
      },
    }));

    try {
      const response = await axios.post(
        `${this.props.chimeraserv.urlPost}/group/create/brand`,
        {
          grpKey: this.state.field.group.value,
          name: this.state.field.name.value,
          levels: this.state.field.level.value
            .filter((level) => level.status)
            .map((level) => level.id),
          users: this.state.field.user.value.filter((user) => user.state),
        },
        {
          headers: {
            Authorization: this.props.user.data.usrKey,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data && !response.data.__v) {
        this.reset();
        this.setState((prevState) => ({
          form: {
            ...prevState.form,
            message: "Brand Created",
          },
        }));
      }
    } catch (error) {
      this.setState((prevState) => ({
        form: {
          ...prevState.form,
          message: JSON.stringify(error),
        },
      }));
    }
  };

  render() {
    return (
      <div className={"custForm"}>
        {this.renderTitle()}

        <div className={["viewTitle"]}>Edit Brand</div>
        <form onSubmit={() => {}} className={["form"]}>
          <div className={["form-group"]}>
            <label htmlFor="group">
              Group <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.group.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.group.state).icon]}
            />
            <SearchDropdown
              data={this.state.field.group.data}
              name="group"
              value={this.state.field.group.name}
              searchFields={["name", "grpKey"]}
              displayField="name"
              placeholder="Search business group..."
              required={true}
              showIcon={false}
              state={!!this.state.field.group.state}
              onSelect={(group) => {
                // Simulate a change event for valueChanged
                const fakeEvent = {
                  target: {
                    id: "group",
                    value: JSON.stringify({
                      name: group.name,
                      grpKey: group.grpKey,
                      _id: group._id,
                    }),
                    getAttribute: (attr) => {
                      if (attr === "data-field") return null;
                      if (attr === "data-key") return null;
                      return undefined;
                    },
                  },
                };
                this.valueChanged(fakeEvent);
              }}
              allowClear={true}
              noResultsText="No groups found"
            />
            {/* <select
              className="form-control"
              id="group"
              onChange={this.valueChanged}
            >
              <option defaultValue={0} value={0}>
                -- business group of brand --
              </option>
              {this.state.field.group.data.map((data, key) => (
                <option
                  value={JSON.stringify({
                    name: data.name,
                    grpKey: data.grpKey,
                    _id: data._id,
                  })}
                  key={key}
                >
                  {data.name}
                </option>
              ))}
            </select> */}
          </div>
          <div className={["form-group"]}>
            <label>
              Brand Name <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.name.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.name.state).icon]}
            />
            <div className={["field"]}>
              <input
                type={"text"}
                className={["form-control"]}
                id={"name"}
                placeholder={"enter brand name"}
                value={this.state.field.name.value}
                onChange={this.valueChanged}
              />
              <span>{this.state.field.name.message}</span>
            </div>
          </div>
          <div className={["form-group"]}>
            <label htmlFor="type">
              Levels <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.level.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.level.state).icon]}
            />
            <div className={["custom-control", "custom-checkbox"].join(" ")}>
              {this.state.field.level.value.map((data, key) => {
                return (
                  <div key={key}>
                    <input
                      type={"checkbox"}
                      className={["custom-control-input"]}
                      name="level"
                      id={key}
                      data-key={key}
                      onChange={this.valueChanged}
                      checked={data.status}
                      value={data.id}
                      data-field={"level"}
                    />
                    <label className={"custom-control-label"} htmlFor={key}>
                      {data.name}
                    </label>
                  </div>
                );
              })}
              <div className={["field"]}>
                <span>{this.state.field.level.message}</span>
              </div>
            </div>
          </div>
          <div className={["form-group"]}>
            <label>
              Users <span></span>
            </label>
            <div className={"multipart"}>
              {this.state.field.user.value.map((data, key) => (
                <div className={["field"]} key={key}>
                  <div className={"part"}>
                    <FontAwesomeIcon
                      className={["icon", this.checker(data.state).style].join(
                        " "
                      )}
                      icon={["fas", this.checker(data.state).icon]}
                    />
                    <input
                      type={"text"}
                      className={["form-control", "custField"].join(" ")}
                      id={"name"}
                      placeholder={"enter level name"}
                      value={data.name}
                      data-key={key}
                      onChange={this.valueChanged}
                      data-field={"user"}
                    />
                    {
                      <button
                        type={"button"}
                        onClick={() =>
                          key === 0 ? this.add() : this.remove(key)
                        }
                        className={[
                          "custBtn",
                          key === 0 ? "add" : "remove",
                        ].join(" ")}
                      >
                        <FontAwesomeIcon
                          className={[
                            "icon",
                            this.checker(this.state.field.user.state).style,
                          ].join(" ")}
                          icon={key === 0 ? "plus" : "minus"}
                        />
                      </button>
                    }
                  </div>
                  <span>{data.message}</span>
                </div>
              ))}
            </div>
          </div>
          {this.state.form.message ? (
            <div className={["message", "form-group"].join(" ")}>
              <FontAwesomeIcon
                className={["icon", "correct"].join(" ")}
                icon={"check-circle"}
              />
              {this.state.form.message}
            </div>
          ) : (
            <div />
          )}
          <button
            type={"button"}
            className={["btn btn-primary"]}
            disabled={this.state.form.state ? false : true}
            onClick={() => this.submit()}
          >
            Save
          </button>
          <button
            type={"button"}
            onClick={() => this.reset()}
            className={["btn btn-primary", "reset"].join(" ")}
          >
            Reset
          </button>
        </form>
      </div>
    );
  }
}
